import { Directive, EventEmitter, Output } from '@angular/core';

@Directive({
  exportAs: 'filter',
  selector: '[portalDataTableFilter]',
  standalone: false,
})
export class DataTableFilterDirective<T> {
  @Output()
  filterChanged = new EventEmitter<T[]>();

  constructor() {}
}
